import { LegalPage } from "@/pages/Privacy";

export default function Terms() {
  return <LegalPage kind="terms" />;
}
